<div class="container-sm pb-5 main-container">
<div class="row row-xs">
    <div class="col-6 col-md-4">
        <div *ngIf="showAttendanceRateFeatures" class="form-check mb-3" style="margin-bottom: 0px !important;">
            <input id="showEmptyIntervals" class="form-check-input" type="checkbox" [(ngModel)]="showEmptyIntervals">
            <label class="form-check-label" for="showEmptyIntervals">
                {{ 'blocking.showAllIntervals' | translate }}
            </label>
        </div>
    </div>
</div>      

    <!-- filters -->
    <div class="filters-container px-2 px-sm-0 mb-2">
        <div class="row row-xs">
            <div class="col-6 col-md-4">
                <div class="form-col">
                    <label class="mb-1">{{ 'blocking.interval' | translate }}</label>
                    <app-dropdown *ngIf="intervals.length > 0 && (interval$ | async) as interval" [model]="interval"
                        [items]="intervals" [displayProperty]="'display'" [valueProperty]="'value'"
                        (onChange)="changeInterval($event)">
                    </app-dropdown>
                </div>
            </div>
            <div class="col-6 col-md-4">
                <div class="form-col">
                    <label class="mb-1">{{ 'blocking.purpose' | translate }}</label>
                    <app-dropdown *ngIf="purposes.length > 0 && (purpose$ | async) as purpose" [model]="purpose"
                        [items]="purposes" [displayProperty]="'display'" [valueProperty]="'value'"
                        (onChange)="changePurpose($event)">
                    </app-dropdown>
                </div>
            </div>
            <div class="col-6 col-md-4">
                <div class="form-col">
                    <label class="mb-1">{{ 'blocking.category' | translate }}</label>
                    <app-dropdown *ngIf="categories.length > 0 && (category$ | async) as category" [model]="category"
                        [items]="categories" [displayProperty]="'display'" [valueProperty]="'value'"
                        (onChange)="changeCategory($event)">
                    </app-dropdown>
                </div>
            </div>
        </div>
    </div>

  

    <!-- shifts -->
    <div *ngIf="processedShifts != null" id="blocking-list" class="list-item-group">
        <div *ngFor="let shift of processedShifts; let f = first"
            class="list-item-collapsible list-item-collapsible-has-value">
            <a class="list-item-collapsible-header list-item-collapsible-header-caret" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse_' + shift.shiftId"
                [attr.aria-expanded]="expandedShift != null && expandedShift.shiftId == shift.shiftId ? true : false"
                (click)="expandedShift = shift">
                <span class="list-item-collapsible-label list-item-collapsible-label-static">
                    {{getShiftTitle(shift.type)}}
                </span>
                <span class="list-item-collapsible-selection list-item-collapsible-selection-static">
                    <span class="counts ml-auto text-sm mr-2">
                        P <span class="text-link text-normal">
                            {{shift.totalCovers}}
                        </span>&nbsp;&nbsp;R <span class="text-link text-normal">
                            {{shift.totalRes}}
                        </span>
                    </span>
                </span>
            </a>
            <div [attr.id]="'collapse_' + shift.shiftId" class="collapse"
                [class.show]="expandedShift != null && expandedShift.shiftId == shift.shiftId"
                data-bs-parent="#blocking-list">
                <div class="list-item-collapsible-content">
                    <table class="ihost-table">
                        <thead>
                            <tr>
                                <th>{{ 'blocking.table.time' | translate }}</th>
                                <th>{{ 'blocking.table.people' | translate }}</th>
                                <th>{{ 'blocking.table.revs' | translate }}</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="shift.parts != null">
                            <!-- <tr *ngFor="let part of shift.parts | filter:filterShiftParts"> -->
                                <tr *ngFor="let part of shift.parts | filter:filterShiftParts:showEmptyIntervals">
                                <td>
                                    {{part.label}}
                                </td>
                                <td>
                                    <ng-container *ngIf="showAttendanceRateFeatures; else coversOnly">
                                        <span [class.attendance-limit-reached]="part.totalCovers >= part.expectedCovers">
                                            {{ part.totalCovers }}/{{ part.expectedCovers }}
                                        </span>
                                    </ng-container>
                                
                                    <ng-template #coversOnly>
                                        {{ part.totalCovers }}
                                    </ng-template>
                                </td>
                                <td>
                                    {{part.totalRes}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>